import { useEffect, useRef, useState, Fragment } from "react";
import { useSelector } from "react-redux";
import { createPopper } from "@popperjs/core";
import _uniqueId from "lodash/uniqueId";
import DropdownOpzioneItem from "./dropdownOpzioneItem/DropdownOpzioneItem";

const ProductOpzione = ({
  idOption,
  nameOption,
  onDropdownOptionChange,
  onKitHandler,
}) => {
  const deviceType = useSelector((state) => state.device);
  const pageContent = useSelector((state) => state.currentPage.pageContent);
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );

  const [dropdownPopoverShow, setDropdownPopoverShow] = useState(false);
  const btnDropdownRef = useRef();
  const popoverDropdownRef = useRef();
  const openDropdownPopover = () => {
    console.log("openDropdownPopover");
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  const onOptionClick = (idClicked, nameClicked) => {
    closeDropdownPopover();
    onDropdownOptionChange(idClicked, nameClicked);
    console.log("onOptionClick");
  };

  const elencoOpzione = Object.keys(pageContent.detail.variantiOpzione).map(
    (key) => {
      const { id, name } = pageContent.detail.variantiOpzione[key];
      return (
        <DropdownOpzioneItem
          key={_uniqueId("dropdownOptionItem_")}
          idOption={id}
          labelOption={name}
          onItemClickHandler={onOptionClick}
        />
      );
    }
  );

  const titoloOpzione =
    pageContent.detail.titoloopzioni != ""
      ? pageContent.detail.titoloopzioni.toUpperCase()
      : genericheTranslation.nostreopzioni.itemName.toUpperCase();

  useEffect(() => {
    console.log("productOpzione");
  }, []);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1536 },
      items: 1,
    },
    bigtablet: {
      breakpoint: { max: 1536, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 640 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };

  const removeArrowsOnDeviceType = [];

  return (
    <div className="flex flex-col mt-6 sm:mt-12 xl:mt-6 2xl:mt-12 mb-8 relative">
      <span className="text-xl text-ribola-quicksand font-opensanssemibold flex items-center justify-between">
        {titoloOpzione}
      </span>
      <div
        className="text-ribola-astral cursor-pointer mt-3 2xl:mt-6"
        onClick={() => {
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <button
          className="border-2 border-ribola-astral outline-none focus:outline-none text-ribola-dove-gray text-left text-xs sm:text-sm xl:text-xs 3xl:text-sm w-full h-100"
          type="button"
          ref={btnDropdownRef}
        >
          <span className="flex justify-between items-center px-3 py-2 leading-snug">
            {nameOption}
            <i className="far fa-chevron-down text-xs mx-2"></i>
          </span>
        </button>
      </div>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "w-full border-l-2 border-r-2 border-b-2 border-ribola-astral overflow-hidden z-50 text-xs cursor-pointer"
        }
      >
        {elencoOpzione}
      </div>
    </div>
  );
};

export default ProductOpzione;
